import { NgModule } from '@angular/core'

// Core PrimeNG modules that are used across the entire app
import { ButtonModule } from 'primeng/button'
import { InputTextModule } from 'primeng/inputtext'
import { SelectModule } from 'primeng/select'
import { DialogModule } from 'primeng/dialog'
import { TableModule } from 'primeng/table'
import { DatePickerModule } from 'primeng/datepicker'
import { CheckboxModule } from 'primeng/checkbox'
import { RadioButtonModule } from 'primeng/radiobutton'
import { ToastModule } from 'primeng/toast'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { PopoverModule } from 'primeng/popover'
import { MenuModule } from 'primeng/menu'
import { PaginatorModule } from 'primeng/paginator'

/**
 * Core PrimeNG module that provides the most commonly used UI components.
 * This reduces bundle size by only importing essential components.
 */
@NgModule({
  exports: [
    ButtonModule,
    InputTextModule,
    SelectModule,
    DialogModule,
    TableModule,
    DatePickerModule,
    CheckboxModule,
    RadioButtonModule,
    ToastModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    PopoverModule,
    MenuModule,
    PaginatorModule,
  ],
})
export class CorePrimeNGModule {}
